module.exports = [
	{
		"name": "Data Processing Addendum (DPA)",
		"papers": [
			{
				"title": "Data Processing Addendum (DPA)",
				"id": "auth0-dpa",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg",
				"date": "October, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/legal/files/Auth0-DPA.pdf"
					},
					{
						"action": "open",
						"file": "https://cdn.auth0.com/website/legal/files/Auth0-DPA.pdf"
					}
				]
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/dpa/data/dpaPapers.json
// module id = 1409
// module chunks = 0